/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Account_Resend_CodeInputs */

const en_delete_account_resend_code = /** @type {(inputs: Delete_Account_Resend_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send new code`)
};

const es_delete_account_resend_code = /** @type {(inputs: Delete_Account_Resend_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar código nuevo`)
};

const ar_delete_account_resend_code = /** @type {(inputs: Delete_Account_Resend_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إرسال رمز جديد`)
};

/**
* | output |
* | --- |
* | "Send new code" |
*
* @param {Delete_Account_Resend_CodeInputs} inputs
* @param {{ locale?: "en" | "es" | "ar" }} options
* @returns {LocalizedString}
*/
export const delete_account_resend_code = /** @type {((inputs?: Delete_Account_Resend_CodeInputs, options?: { locale?: "en" | "es" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Account_Resend_CodeInputs, { locale?: "en" | "es" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delete_account_resend_code(inputs)
	if (locale === "es") return es_delete_account_resend_code(inputs)
	return ar_delete_account_resend_code(inputs)
});